export default () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // TODO: add here the logic to define the browser
  return userAgent;
};
